var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-help-6597166",
    transform: "translate(-60 -60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235604",
    "data-name": "Path 235604",
    d: "M72,84a12.016,12.016,0,1,1,8.481-3.519A12,12,0,0,1,72,84Zm0-23.3a11.328,11.328,0,1,0,7.995,3.313A11.314,11.314,0,0,0,72,60.7Z",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235605",
    "data-name": "Path 235605",
    d: "M298.339,304.848a6.165,6.165,0,1,1,4.357-1.808,6.145,6.145,0,0,1-4.357,1.808Zm0-11.684h0a5.535,5.535,0,1,0,3.912,1.612,5.534,5.534,0,0,0-3.912-1.612Z",
    transform: "translate(-226.335 -226.676)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235606",
    "data-name": "Path 235606",
    d: "M477.465,78.433a.37.37,0,0,1-.385-.334l-.753-5.842a.41.41,0,0,1,.337-.443.416.416,0,0,1,.431.337l.753,5.842h0a.407.407,0,0,1-.319.446Zm3.985,0H481.4a.385.385,0,0,1-.322-.446l.771-5.842a.388.388,0,0,1,.446-.331.4.4,0,0,1,.337.449l-.783,5.836a.413.413,0,0,1-.4.334Z",
    transform: "translate(-407.457 -11.51)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235607",
    "data-name": "Path 235607",
    d: "M873.59,482.938h-.049l-5.842-.768a.4.4,0,1,1,.112-.783l5.836.783a.385.385,0,0,1,.337.434.422.422,0,0,1-.395.334Zm-5.842-4.753a.37.37,0,0,1-.385-.319.44.44,0,0,1,.337-.449l5.842-.753h0a.409.409,0,0,1,.449.337.419.419,0,0,1-.343.431l-5.836.753Z",
    transform: "translate(-790.255 -407.784)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235608",
    "data-name": "Path 235608",
    d: "M482.042,873.666a.358.358,0,0,1-.382-.337l-.771-5.824a.4.4,0,0,1,.322-.449.41.41,0,0,1,.449.337l.783,5.824a.41.41,0,0,1-.337.449Zm-5.539,0h-.03a.38.38,0,0,1-.337-.449l.753-5.824a.392.392,0,0,1,.449-.337.367.367,0,0,1,.319.449l-.753,5.824a.383.383,0,0,1-.4.337Z",
    transform: "translate(-407.266 -789.954)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235609",
    "data-name": "Path 235609",
    d: "M72.225,482.833a.376.376,0,0,1-.367-.334.4.4,0,0,1,.337-.434l5.842-.783a.407.407,0,0,1,.446.337.395.395,0,0,1-.337.446l-5.855.768Zm5.861-4.753h-.049l-5.858-.753a.382.382,0,0,1-.322-.431.388.388,0,0,1,.449-.337l5.839.753h0a.389.389,0,0,1,.337.449.379.379,0,0,1-.4.319Z",
    transform: "translate(-11.554 -407.68)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235610",
    "data-name": "Path 235610",
    d: "M396.128,401.8a5.29,5.29,0,1,1,2.661-.707,5.3,5.3,0,0,1-2.661.707Zm0-9.809a4.5,4.5,0,1,0,2.259.592,4.513,4.513,0,0,0-2.259-.592Z",
    transform: "translate(-324.13 -324.486)",
    fill: "#1d1d1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.7a8af30f9bf47619d6f0bac3a5735f3b.svg";
export { ForwardRef as ReactComponent };